import {
  useMemo,
  useState
} from "react";

import type {
  ProductImage
} from "../../types/catalog";
import {
  productImageUrl
} from "../../utils/product-image";

interface ProductImageGalleryProps {
  productName: string;
  images: ProductImage[];
}

export function ProductImageGallery({
  productName,
  images
}: ProductImageGalleryProps) {
  const orderedImages = useMemo(
    () =>
      images
        .slice()
        .sort(
          (left, right) => {
            if (
              left.isPrimary !==
              right.isPrimary
            ) {
              return left.isPrimary
                ? -1
                : 1;
            }

            return (
              left.displayOrder -
              right.displayOrder
            );
          }
        ),
    [images]
  );

  const [
    selectedImageId,
    setSelectedImageId
  ] = useState<string | null>(null);

  const selectedImage =
    orderedImages.find(
      (image) =>
        image.id === selectedImageId
    ) ??
    orderedImages[0] ??
    null;

  return (
    <div>
      <div className="flex aspect-square items-center justify-center overflow-hidden rounded-[2.5rem] bg-[#eee6dc]">
        {selectedImage ? (
          <img
            src={productImageUrl(
              selectedImage.id
            )}
            alt={
              selectedImage.altText ??
              productName
            }
            className="h-full w-full object-contain"
          />
        ) : (
          <span className="font-serif text-6xl text-[#5e3b2c]">
            RiNi
          </span>
        )}
      </div>

      {orderedImages.length > 1 && (
        <div className="mt-4 grid grid-cols-4 gap-3 sm:grid-cols-5">
          {orderedImages.map(
            (image) => {
              const selected =
                image.id ===
                selectedImage?.id;

              return (
                <button
                  key={image.id}
                  type="button"
                  onClick={() =>
                    setSelectedImageId(
                      image.id
                    )
                  }
                  className={[
                    "aspect-square overflow-hidden rounded-2xl border-2 bg-[#f5f2ed] transition",
                    selected
                      ? "border-[#5e3b2c]"
                      : "border-transparent hover:border-[#5e3b2c]/30"
                  ].join(" ")}
                >
                  <img
                    src={productImageUrl(
                      image.id
                    )}
                    alt={
                      image.altText ??
                      productName
                    }
                    className="h-full w-full object-cover"
                    loading="lazy"
                  />
                </button>
              );
            }
          )}
        </div>
      )}
    </div>
  );
}
